angular
    .module('festzelt-os.modules.tickets.main')
    .factory('Ticket', [
        'locale',
        'Resource',
        Ticket
    ]);

function Ticket(locale, Resource) {
    return Resource.make('tickets');
}



// WEBPACK FOOTER //
// ./src/app/modules/tickets/main/factories/ticket.js